import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { GtmEventAction, GtmLoginMethod, GtmRegistrationType } from "@obg/gtm.types/adaptive";
import { CommonState } from "@obg/ngx.common";
import { Jurisdiction } from "@obg/ngx.core";

import { RegistrationTelemetryAction } from "./registration-telemetry.action";
import { RegistrationTelemetryEventName, SmartIdRegistrationTelemetryEvent } from "./registration-telemetry.model";

@Injectable({
	providedIn: "root",
})
export class RegistrationTelemetryService {
	constructor(
		private registrationTelemetryAction: RegistrationTelemetryAction,
		private store: Store<CommonState>
	) {}

	uiInteractionEvent(
		event: RegistrationTelemetryEventName | GtmEventAction | SmartIdRegistrationTelemetryEvent,
		registrationType?: Jurisdiction | GtmLoginMethod,
		status?: string,
		registrationMethod?: GtmRegistrationType
	) {
		this.store.dispatch(
			this.registrationTelemetryAction.uiInteractionEvent({ event, registrationType, status, registrationMethod })
		);
	}

	uiInteractionFieldEvent(
		field: string,
		registrationType?: Jurisdiction | GtmLoginMethod,
		registrationMethod?: GtmRegistrationType,
		registrationStep?: number
	) {
		this.store.dispatch(
			this.registrationTelemetryAction.uiInteractionFieldEvent({
				field,
				registrationType,
				registrationMethod,
				registrationStep,
			})
		);
	}
}
